import { createStandardAction } from 'typesafe-actions';
export var appConfigActions = {
  setAppName: createStandardAction('APP_CONF_SET_APP_NAME')(),
  setCompanyName: createStandardAction('APP_CONF_SET_COMPANY_NAME')(),
  setAppLogo: createStandardAction('APP_CONF_SET_APP_LOGO')(),
  setHeaderLogo: createStandardAction('APP_CONF_SET_HEADER_LOGO')(),
  setPageTitle: createStandardAction('APP_CONF_SET_PAGE_TITLE')()
};